import React from 'react';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

const PROVISION_DELETION_CONFIRM_MESSAGE_PROVISION_FRAGMENT = gql(`
  fragment ProvisionDeletionConfirmMessage_provision on Provision {
    id
    isSsoDefault
  }
`);

interface ProvisionDeletionConfirmMessageProps {
  provision: DocumentType<
    typeof PROVISION_DELETION_CONFIRM_MESSAGE_PROVISION_FRAGMENT
  >;
}

const ProvisionDeletionConfirmMessage = ({
  provision,
}: ProvisionDeletionConfirmMessageProps) => {
  if (provision.isSsoDefault) {
    return (
      <>
        This is the default provision. You can choose a new default from the
        Authentication settings.
      </>
    );
  }

  return null;
};

export default ProvisionDeletionConfirmMessage;
